/**
 * Template for equipement filter
 * @param {Object} facette - filter[facetteName]
 * @param {Object} wordings - SEARCH_SCRIPTS.WORDING_SEARCH
 * @return {string} - HTML content
 */
export const equipmentTpl = (facette, wordings) => {
  const facetteName = facette.code.toLowerCase();
  const codeWording = 'facette_' + facetteName + '_label_mobile';
  let htmlFacette = `
    <div class="searchFilters-filterTitle" id="filter_${facetteName}">${wordings[codeWording]}</div>
    <div class="searchFilters-filterBoxContainer searchFilters-filterBoxContainer--equipment">`;

  // build form element
  let count = 0;
  let groupedItems = {};

  $.each(facette.values, (index, item) => {
    const type = item.type || '';

    // Groupement des éléments par type
    if (!groupedItems[type]) {
      groupedItems[type] = [];
    }

    groupedItems[type].push(item);
    count++;
  });

  // sort by type with order
  const order = ['general', 'bedroom', 'bathroom', 'kitchen', 'outdoor'];
  const types = Object.keys(groupedItems).sort((a, b) => {
    const indexA = order.indexOf(a.toLowerCase());
    const indexB = order.indexOf(b.toLowerCase());

    return indexA - indexB;
  });

  // browse types
  types.forEach((type) => {
    if (order.includes(type.toLowerCase())) {
      htmlFacette += `
      <div class="equipmentCategory">
        <span class="searchFilters-filterSubtitle">${wordings['filterEquipmentLabel_' + type.toLowerCase()]}</span>
        <div class="searchFilters-filterListItems">`;
      groupedItems[type].forEach((item) => {
        const htmlChecked = item.selected ? ' checked="checked"' : '';
        const htmlDisabled = item.enabled || item.checked ? '' : ' u-disabled';
        const inputName = 'facet[' + facette.code + '][]';
        htmlFacette += `
          <div class="searchFilters-filterItem equipmentItem${htmlDisabled}">
            <label for="facette_${facetteName}_${item.key}">
              <div class="form-checkboxContainer">
                <input name="${inputName}" id="facette_${facetteName}_${item.key}" value="${item.key}" class="form-checkbox js-filterInput${htmlDisabled}" type="checkbox" data-facette="${facetteName}"${htmlChecked}>
                <span class="form-checkboxLabel form-label">${item.value}</span>
              </div>
            </label>
          </div>`;
      });
      htmlFacette += `
        </div>
      </div>`;
    }
  });

  htmlFacette += `
    </div>
    <div class="searchFilters-opener js-toogleOpener" data-target="equipment" data-labelsee="${wordings.seeMoreLabel}" data-labelhide="${wordings.seeLessLabel}">${wordings.seeMoreLabel}</div>`;

  return htmlFacette;
};
